<template>
  <v-container fluid class="px-8">
    <v-row>
      <v-col cols="12" md="8" class="pl-0">
        <div
          v-if="!!property.images.length"
          class="pa-3 d-flex flex-row fill-width align-center white rounded-lg elevation-3"
          style="gap: 8px"
        >
          <div
            class="rounded-lg"
            style="width: 100px; scrollbar-gutter: stable; max-height: 600px; overflow: auto"
          >
            <v-img
              v-for="image in property.images"
              :src="imageUrl(image.thumbUrl)"
              :key="image.id"
              width="70"
              height="70"
              dark
              class="mb-1 rounded-lg"
              style="cursor: pointer"
              :style="
                !!selectedImage && image.id == selectedImage.id
                  ? 'border:2px solid black'
                  : ''
              "
              @click="changeActiveImage(image)"
            ></v-img>
          </div>
          <div
            @click="imageModal = true"
            class="pl-1 fill-width d-flex align-center"
            style="cursor: pointer; min-width: 0; height: 600px"
          >
            <v-img
              v-if="!!selectedImage"
              :src="imageUrl(selectedImage.smallUrl)"
              dark
              max-height="600"
              contain
              class="rounded-lg"
            ></v-img>
          </div>
          <v-dialog fullscreen v-model="imageModal">
            <v-card style="background-color: rgba(0,0,0,.7)">
              <v-img
                @click.stop=""
                v-if="!!selectedImage"
                :src="imageUrl(selectedImage.url)"
                dark
                contain
                style="max-height: 100vh"
                class="text-right pa-3"
              >
                <v-btn @click="imageModal = false" fab color="white">
                  <v-icon color="primary">
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-img>
            </v-card>
          </v-dialog>
        </div>
      </v-col>

      <v-col cols="12" md="4" class="d-flex flex-column">
        <v-card
          class="rounded-lg mb-3 elevation-3 d-flex flex-row align-center justify-space-between"
        >
          <div>
            <v-card-title class="font-weight-regular">
              Observaciones
            </v-card-title>

            <v-card-subtitle>
              ({{ observations.length }}) gestiones sobre esta propiedad
            </v-card-subtitle>
          </div>

          <div class="px-3">
            <observations
              @reload="fetchObservations"
              :observations="observations"
            ></observations>
          </div>
        </v-card>

        <v-card
          class="white rounded-lg elevation-3 d-flex flex-column"
          style="max-height: calc(624px - 98px) !important"
        >
          <v-card-title class="font-weight-regular pb-0">
            Asesores
          </v-card-title>

          <v-list dense style="flex-grow: 1; overflow: auto" color="white">
            <template v-for="(employee, i) in property.staff">
              <v-list-item class="px-1">
                <v-list-item-avatar>
                  <v-icon color="red">
                    mdi-account
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-html="employee.name"></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="employee.rol"
                  ></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action class="pr-2">
                  <v-btn
                    fab
                    x-small
                    depressed
                    color="error"
                    @click="detachStaff(employee.id)"
                  >
                    <v-icon color="white">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>

              <v-divider></v-divider>
            </template>

            <v-list-item dense class="px-1 mt-2">
              <v-list-item-avatar>
                <v-icon color="success">
                  mdi-account
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-select
                  outlined
                  v-model="employee"
                  :items="staff"
                  hide-details
                  dense
                  class="rounded-lg"
                  label="Asignar asesor..."
                  item-value="id"
                >
                  <template slot="item" slot-scope="data">
                    <!-- HTML that describe how select should render items when the select is open -->
                    {{ data.item.name }}
                    {{ data.item.city ? `- ${data.item.city}` : "" }}
                  </template>

                  <template slot="selection" slot-scope="data">
                    <!-- HTML that describe how select should render items when the select is open -->
                    {{ data.item.name }}
                    {{ data.item.city ? `- ${data.item.city}` : "" }}
                  </template>
                </v-select>
              </v-list-item-content>

              <v-list-item-action class="pr-2">
                <v-btn
                  :disabled="!employee"
                  @click="attachStaff(employee)"
                  fab
                  depressed
                  x-small
                  color="success"
                >
                  <v-icon color="white">mdi-plus</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <v-col
        class="white rounded-lg elevation-3"
        cols="12"
        :md="property.blueprintUrl ? 6 : 12"
      >
        <v-card flat color="transparent">
          <v-card-title class="pt-0 pb-2 font-weight-regular"
            >Descripción</v-card-title
          >
          <v-card-text v-html="property.description"> </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" class="pr-0 py-0">
        <v-card
          class="white rounded-lg elevation-3 pa-3"
          v-if="property.blueprintUrl"
        >
          <v-card-title class="pt-0 pb-2 font-weight-regular">
            Plano de la propiedad
          </v-card-title>

          <v-img
            :src="imageUrl(property.blueprintUrl)"
            max-height="400"
            dark
            contain
            class="mb-1 rounded-lg"
            style="cursor: pointer"
            @click="blueprintDialog = !blueprintDialog"
          ></v-img>

          <v-dialog fullscreen v-model="blueprintDialog">
            <v-card style="background-color: rgba(0,0,0,.7)">
              <v-img
                :src="imageUrl(property.blueprintUrl)"
                dark
                contain
                style="max-height: 100vh"
                class="text-right pa-3"
              >
                <v-btn @click="blueprintDialog = false" fab color="white">
                  <v-icon color="primary">
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-img>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>

      <v-col cols="12" class="white rounded-lg elevation-3 mt-3">
        <v-row>
          <v-col
            :key="characteristic.id"
            v-for="(characteristic, i) in property.characteristics"
            v-if="characteristic.value && characteristic.value != '0'"
            cols="6" sm="4" md="3"
            class="pb-0"
          >
            <v-card-subtitle class="py-0 caption">{{
              characteristic.name
            }}</v-card-subtitle>
            <v-card-title class="pt-0 font-weight-regular">{{
              characteristic.value
            }}</v-card-title>
          </v-col>
        </v-row>

        <v-row v-if="rentalConditions.length">
          <v-col class="pt-0" cols="12">
            <v-row>
              <v-col cols="12">
                <v-card-title class="py-0 font-weight-regular">Condiciones de alquiler</v-card-title>
              </v-col>
              <v-col
                cols="6" sm="4" md="3"
                v-for="c in rentalConditions"
                :key="c.name"
                class="py-0"
              >
                <v-card-subtitle class="pt-0 pb-2">- {{ c.name }}: {{ c.value }}</v-card-subtitle>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row
          :key="i"
          v-for="(additional_feature, i) in property.features
            .additional_features"
        >
          <v-col class="pt-0" cols="12">
            <v-row>
              <v-col cols="12">
                <v-card-title class="py-0 font-weight-regular">{{
                  additional_feature.name
                }}</v-card-title>
              </v-col>
              <v-spacer></v-spacer>
              <v-col
                cols="6" sm="4" md="3"
                :key="value"
                v-for="value in additional_feature.values"
                class="py-0 d-flex justify-space-between"
              >
                <v-card-subtitle class="pt-0 pb-2"
                  >- {{ value }}</v-card-subtitle
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DetachStaff, AttachStaff } from "@/graphql/mutations/staff";
import { Staff } from "@/graphql/queries/staff";
import { Observations as ObservationsQuery } from "@/graphql/queries/properties";

import Observations from "@/components/properties/observations/Observations";

export default {
  name: "ShowCharacteristics",
  data() {
    return {
      tabs: 0,
      employee: null,
      selectedImage: null,
      imageModal: false,
      blueprintDialog: false,
      staff: [],
      observations: []
    };
  },

  props: ["property"],

  computed: {
    rentalConditions() {
      const f = (this.property && this.property.features) || {};
      if (!(f.operation_type || {}).rent) return [];
      const PETS = { yes: "Sí", no: "No", ask: "Consultar" };
      const out = [];
      if (PETS[f.pets]) out.push({ name: "Admite mascotas", value: PETS[f.pets] });
      if (f.max_occupants) out.push({ name: "Máx. ocupantes", value: f.max_occupants });
      return out;
    }
  },

  methods: {
    changeActiveImage(image) {
      this.selectedImage = image;
    },

    imageUrl(url) {
      return process.env.VUE_APP_RAILS_URL + url;
    },

    detachStaff(id) {
      this.$apollo
        .mutate({
          mutation: DetachStaff,
          variables: {
            input: {
              id: id,
              propertyId: this.property.id
            }
          }
        })
        .then(res => {
          this.$router.go();
        });
    },

    attachStaff(id) {
      this.$apollo
        .mutate({
          mutation: AttachStaff,
          variables: {
            input: {
              id: id,
              propertyId: this.property.id
            }
          }
        })
        .then(res => {
          this.$router.go();
        });
    },

    fetchStaff() {
      this.$apollo
        .query({
          query: Staff,
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.staff = res.data.staff.filter(
            v => !this.property.staff.map(v => v.id).includes(v.id)
          );
        });
    },

    fetchObservations() {
      this.$apollo
        .query({
          query: ObservationsQuery,
          variables: {
            id: this.$route.params.id
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.observations = res.data.observations;
        });
    }
  },

  created() {
    this.selectedImage = this.property.images[0];

    this.fetchStaff();
    this.fetchObservations();
  },

  components: {
    Observations
  }
};
</script>
